import { type GetCustomerResponse, GetCustomerResponseSchema } from '@vy/api-definition';
import type { VyCustomerNotFoundError } from '@vy/error';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type {
  CustomBaseUseQueryOptions,
  CustomUseQueryOptions,
} from './requests-types/custom-use-query-options';
import { queryKeys } from '../../services/query-key/query-keys';

export function useCustomerOptions(
  customerId: string,
  api = getPrivateApi(),
  options?: CustomBaseUseQueryOptions<GetCustomerResponse, VyCustomerNotFoundError>,
): CustomBaseUseQueryOptions<GetCustomerResponse, VyCustomerNotFoundError> {
  return {
    queryKey: queryKeys.customer(customerId),
    suspense: true,
    ...options,
    queryFn: async () => {
      const getCustomerResponse = await api.getCustomer({ customerId });

      return GetCustomerResponseSchema.parse(getCustomerResponse);
    },
  };
}

export function useCustomerWithoutSuspense(
  customerId: string,
  options?: CustomUseQueryOptions<GetCustomerResponse, VyCustomerNotFoundError>,
) {
  const customerOptions = useCustomerOptions(customerId, undefined, { suspense: false });

  return useQuery({ ...customerOptions, ...options });
}

export function useCustomer(
  customerId: string,
  options?: CustomUseQueryOptions<GetCustomerResponse, VyCustomerNotFoundError>,
) {
  const customerOptions = useCustomerOptions(customerId);

  return useQuery({ ...customerOptions, ...options });
}
